import React, { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Features', href: '#features' },
  { label: 'Pricing', href: '#pricing' },
  { label: 'FAQ', href: '#faq' },
];

const Navigation = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const handleNavClick = (href) => {
    setMenuOpen(false);
    if (href.startsWith('#')) {
      const id = href.slice(1);
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className="sticky top-0 w-full z-50 glass-header border-b border-outline-variant"
      role="navigation"
      aria-label="Main navigation"
    >
      <div className="max-w-container-max mx-auto px-margin-desktop flex justify-between items-center h-20">

        {/* Logo: image + CONSAI in Horizon font */}
        <a href="/" className="flex items-center gap-2.5 no-underline" aria-label="CONSAI Home" data-testid="nav-logo">
          <img src="/consai-logo.png" alt="CONSAI" className="h-8 w-auto" />
          <span className="horizon-font tracking-widest" style={{ fontSize: '17px' }}>
            <span style={{ color: '#ffffff' }}>CONS</span><span style={{ color: '#d7263d' }}>AI</span>
          </span>
        </a>

        {/* Desktop nav */}
        <nav className="hidden md:flex gap-8 items-center" aria-label="Desktop navigation">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
              className="text-sm text-on-surface-variant hover:text-white transition-colors cursor-pointer no-underline"
            >
              {link.label}
            </a>
          ))}
          <div className="h-6 w-px bg-outline-variant mx-2" aria-hidden="true" />
          <a
            href="/login"
            className="text-sm text-on-surface-variant hover:text-white transition-colors no-underline"
            data-testid="nav-login-btn"
          >
            Login
          </a>
          <a
            href="/signup"
            className="bg-white text-on-primary px-5 py-2.5 rounded-lg text-sm font-bold hover:opacity-90 transition-all no-underline"
            data-testid="nav-signup-btn"
          >
            Get Started
          </a>
        </nav>

        {/* Mobile menu button */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden text-white bg-transparent border-0 cursor-pointer p-1"
          aria-label="Toggle navigation menu"
          aria-expanded={menuOpen}
          data-testid="mobile-menu-toggle"
        >
          <span className="material-symbols-outlined" style={{ fontSize: '28px' }}>
            {menuOpen ? 'close' : 'menu'}
          </span>
        </button>
      </div>

      {/* Mobile dropdown */}
      {menuOpen && (
        <div
          className="md:hidden absolute top-full left-0 right-0"
          style={{ background: 'rgba(14, 14, 14, 0.97)', backdropFilter: 'blur(12px)', borderBottom: '1px solid #262626' }}
          data-testid="mobile-menu"
        >
          <div className="max-w-container-max mx-auto px-margin-desktop py-6 flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                className="py-3 text-base text-on-surface-variant hover:text-white border-b border-outline-variant no-underline transition-colors"
              >
                {link.label}
              </a>
            ))}
            <div className="flex flex-col gap-3 pt-4">
              <a
                href="/login"
                className="w-full text-center py-3 executive-border rounded-lg text-white no-underline text-sm"
                data-testid="mobile-login-btn"
              >
                Login
              </a>
              <a
                href="/signup"
                className="w-full text-center py-3 bg-white text-on-primary rounded-lg font-bold no-underline text-sm"
                data-testid="mobile-signup-btn"
              >
                Get Started
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navigation;
